import { useSelector } from 'react-redux'

import useReduxAction from '@hooks/useReduxAction'

const useClientTypes = (options = {}) => {
  const { performHttpRequests } = options || {}

  const entities = useSelector(reduxState => reduxState.entities)
  const { clientTypes } = entities

  useReduxAction('clientTypes', 'loadClientTypes', {}, [performHttpRequests], {
    shouldPerformFn: (entityReducer) => {
      const { errors, loaded, loading } = entityReducer
      return performHttpRequests && !loaded && !loading && !errors.length
    },
  })

  return {
    clientTypes,
  }
}

export default useClientTypes
